export default __webpack_public_path__ + "static/media/setting-search.066b0841.svg";